import request, { Methods, withToken } from "../../../../assets/util/request";

//* ACTIONTYPES --------------------------------------------
export const POST_SERVICE_RESET = 'POST_SERVICE_RESET';
export const POST_SERVICE_LOADING = 'POST_SERVICE_LOADING';
export const POST_SERVICE_SUCCESS = 'POST_SERVICE_SUCCESS';
export const POST_SERVICE_REJECT = 'POST_SERVICE_REJECT';

//* ACTIONS ------------------------------------------------
export const postServiceReset = () => ({ type: POST_SERVICE_RESET });
export const postServiceLoading = () => ({ type: POST_SERVICE_LOADING });
export const postServiceSuccess = (payload) => ({ type: POST_SERVICE_SUCCESS, payload });
export const postServiceReject = (payload) => ({ type: POST_SERVICE_REJECT, payload });

//* REQUEST SERVICE ---------------------------------------
export const postServiceRequest = async (data, getState) => {
    const options = await withToken({
        method: Methods.POST,
        data,
    }, getState);
    return request(`/Clients/web/AddServicesClients`, options);
};


